import { render } from "./ExcelPreview.vue?vue&type=template&id=07da9eba"
import script from "./ExcelPreview.vue?vue&type=script&lang=js"
export * from "./ExcelPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__